/** Helpers for carrying a chosen HPE plan through sign-in / signup. */
const KEY = "hpe_checkout_redirect";

export function safeRedirect(r: string | null | undefined): string | null {
  return r && r.startsWith("/") && !r.startsWith("//") ? r : null;
}

/** Returns the plan name ("yearly" etc.) if the redirect is a membership checkout intent. */
export function planFromRedirect(r: string | null): string | null {
  if (!r || !r.startsWith("/verify-license")) return null;
  const m = r.match(/[?&]plan=(weekly|monthly|yearly)/);
  return m ? m[1] : null;
}

const PLAN_KEY = "hpe_pending_plan";
export type PendingPlan = "weekly" | "monthly" | "yearly";
export const PLAN_LABEL: Record<PendingPlan, string> = { weekly: "Stylist Weekly", monthly: "Stylist Monthly", yearly: "Stylist Yearly" };
/** Remember the plan a visitor chose so it survives verification review (per browser). */
export function rememberPlan(p: string | null) {
  if (p !== "weekly" && p !== "monthly" && p !== "yearly") return;
  try { localStorage.setItem(PLAN_KEY, p); } catch { /* ignore */ }
}
export function getRememberedPlan(): PendingPlan | null {
  try { const v = localStorage.getItem(PLAN_KEY); return v === "weekly" || v === "monthly" || v === "yearly" ? v : null; } catch { return null; }
}
export function clearRememberedPlan() { try { localStorage.removeItem(PLAN_KEY); } catch { /* ignore */ } }

export function rememberRedirect(r: string) { try { localStorage.setItem(KEY, r); } catch { /* ignore */ } }
export function takeRememberedRedirect(): string | null {
  try { const v = localStorage.getItem(KEY); localStorage.removeItem(KEY); return safeRedirect(v); } catch { return null; }
}
